// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";

import Vue from 'vue'
import VueAppInsights from 'vue-application-insights'
import Router from 'vue-router'

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// import 'bootswatch/dist/yeti/bootstrap.css';
// import 'bootswatch/dist/flatly/bootstrap.css';
import 'bootswatch/dist/darkly/bootstrap.css';
import 'c3/c3.css';

import App from './App'
import router from './router'
import { loadScript } from 'esri-loader'
import store from './store';

import "./web.config"; //so that during build process a web.config also output for deployment

import apiService from "@/service/apiService";

Vue.use(BootstrapVue);

Vue.config.productionTip = true

// preload the ArcGIS API
const options = {
  // url: 'https://js.arcgis.com/4.7/',
  // url: 'https://js.arcgis.com/4.8/',
  url: 'https://js.arcgis.com/4.9/',
  // url: 'https://js.arcgis.com/4.10/', //may be bug
  // url: 'https://js.arcgis.com/4.14/'
};
loadScript(options)

if(process.env.__APP_INSIGHTS_KEY__){
  Vue.use(VueAppInsights, {
    id: process.env.__APP_INSIGHTS_KEY__,
    router
  })
}



router.beforeEach((to, from, next) => {
  //if route requriesAuth, check user have related system levels
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var sessionStorage;
    var canAccess = false;
    try{
      sessionStorage = window.sessionStorage;
      canAccess = true
    }catch(e){
      //window.alert('cannot access sessionstorage')
    }

    if(canAccess == false){
        next({
          path: '/'
        })
    }else{
      var portalUserId = sessionStorage['portalUserId'];
      if(!portalUserId){
        next({
          path: '/'
        });
      } else {
        let service = new apiService();
        service.getUserSystemLevelsByUserName([portalUserId]).then((results)=>{
        var toNext = false;

        if (results.data && results.data[0] && results.data[0].user_system_levels) {
          var user_system_levels = results.data[0].user_system_levels;

          function getLevel(sysetmLevels, name, defaultLevel) {
            var level = defaultLevel;
            for (var index in sysetmLevels) {
              var sysetmLevel = sysetmLevels[index];
              if (sysetmLevel.name == name) {
                level = sysetmLevel.level;
                break;
              }
            }
            return level;
          }

          // get AGIS User Type
          var agisUserType = getLevel(user_system_levels, 'AGIS_ADMIN', 0);
          if (agisUserType >= 3) {  // is AGIS Admin
            toNext = true;
          }

          var userLevel = 0;
          if (!toNext)  {
            // get User Level in SYSTEM
            if (to.meta.requiresAuthAdminKey) {
              userLevel = getLevel(user_system_levels, to.meta.requiresAuthAdminKey, 1);
              if (userLevel >= 3) { // System Admin
                toNext = true;
              }
            } else {  // if no system Admin Key provided, assume is authorized user
              userLevel = 1;
            }
          }

          var userRole = 0;
          if (!toNext) {
            if (userLevel > 0) {  // System user
              userRole = getLevel(user_system_levels, to.meta.requiresAuthKey, 0);
              toNext = (userRole > (to.meta.requiresAuthLevel == undefined?0: to.meta.requiresAuthLevel));
            }
          }

          if (!toNext) {
            window.alert('You do not have access right to ' + to.meta.title)
            if (from.name) {
              next({name: from.name});
            } else {
              next('/');
            }
          } else {
            next();
          }
        } else {  // invalid format
          window.alert('You do not have access right to ' + to.meta.title)
          next(false);
        }

          // if(results.data && results.data[0] && results.data[0].user_system_levels.find((eachSystemLevel)=>{
          //   return ( (eachSystemLevel.name == to.meta.requiresAuthKey) && eachSystemLevel.level !=0)
          // })){
          //   next();
          // }else{
          //   window.alert('You do not have access right to ' + to.name)
          //   if(!from.name){
          //     next({
          //       path: '/'
          //     })
          //   }
          // }
        })
      }
    }



  } else {
    next() // make sure to always call next()!
  }
})

Vue.use(Router)

/* eslint-disable no-new */
var vueInstance = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App ref="app"/>',
  store
})

window.vm = vueInstance



// WEBPACK FOOTER //
// ./src/main.js